import * as React from 'react';
import * as themeSwitchStyle from './theme-switcher.module.scss';
import { usePageData } from '../../hooks/page-data';

const setDocumentAttribute = (isDark) => {
    document.documentElement.setAttribute('data-is-dark', isDark);
}

const setDocumentClass = (isDark) => {
    document.body.classList.toggle('t-dark', isDark);
    document.body.classList.toggle('t-light', !isDark);
}

const ThemeSwitcher = () => {
    const [isDark, setIsDark] = React.useState(false);

    const pageData = usePageData();

    const landingPage = React.useMemo(() => pageData?.markdownRemark?.frontmatter?.landing_page|| false, [pageData]);

    React.useEffect(() => {
        let result = null;

        const savedValue = localStorage.getItem('isDark');
        if (savedValue) {
            try {
                result = !landingPage && !!JSON.parse(savedValue);
            } catch (e) {
                console.error(e);
                localStorage.removeItem('isDark');
            }
        }

        setDocumentClass(result);

        setIsDark(result);
    }, [landingPage]);

    React.useEffect(() => {
        setDocumentAttribute(isDark);
    }, [isDark]);

    const setThemeOnClick = () => {
        setIsDark(!isDark);
        localStorage.setItem('isDark', JSON.stringify(!isDark));
        setDocumentClass(!isDark);
    }

    return <>{
        !landingPage && <>
            <button className={`btn-switch-theme ${themeSwitchStyle.switchBtn}`} onClick={setThemeOnClick} aria-label='Switch Theme'>
                <span className={themeSwitchStyle.switchIcon}></span>
            </button>
        </>
    }</>
}

export default ThemeSwitcher;